import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFound from "./config/tokenNotFound";
import { CreateCommentResponse } from "../../api/board_comment";

type Body = {
    content: string,
    parent_id?: number,
    reply_to_comment_id?: number,
    board_id: number,
    device_id: string,
    image_urls?: string[],
}

export type TApiCreateBoardCommentResult = {
  result?: CreateCommentResponse;
};

export const postBoardComment = async (
    body: Body
): Promise<TApiResult  & TApiCreateBoardCommentResult> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;
  const {
    content,
    parent_id = 0,
    reply_to_comment_id,
    board_id,
    device_id,
    image_urls,
  } = body

  return await client()
    .board_comment.post({
      body: {
        content,
        parent_id,
        ...(reply_to_comment_id ? { reply_to_comment_id } : {}),
        board_id,
        device_id,
        image_urls,
      },
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "postBoardComment");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
